

module.exports = __webpack_require__.stylable.create(
    "dropdown3082560593",
    {"classes":{"root":"dropdown3082560593__root","dropdownContent":"dropdown3082560593__dropdownContent"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    3,
    /*! ../node_modules/wix-ui-core/dist/src/components/dropdown/Dropdown.st.css */ 205,
    null
);
